import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NewsletterSubsFormComponent } from "../newsletter-subs-form/newsletter-subs-form.component";

@Component({
  selector: 'app-newsletter-subscription',
  imports: [NewsletterSubsFormComponent],
  templateUrl: './newsletter-subscription.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './newsletter-subscription.component.scss'
})
export class NewsletterSubscriptionComponent {

}
